export default [
    {
        path: 'assistencia-social',
        component: () => import(
            /* webpackChunkName: 'pronto-atendimento-assistencia-social' */
            '@/views/pronto-atendimento/assistencia-social/Index'
        ),
        redirect: 'assistencia-social/index',
        children: [
            {
                name: 'pronto-atendimento-assistencia-social-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-assistencia-social' */
                    '@/views/pronto-atendimento/assistencia-social/List'
                ),
            },
            {
                name: 'pronto-atendimento-assistencia-social-create',
                path: 'create',
                props: true,
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-assistencia-social' */
                    '@/views/pronto-atendimento/assistencia-social/Form.vue'
                ),
            },
            {
                name: 'pronto-atendimento-assistencia-social-edit',
                path: 'edit/:id',
                props: true,
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-assistencia-social' */
                    '@/views/pronto-atendimento/assistencia-social/Form.vue'
                ),
            },
        ]
    }
]